import { render, staticRenderFns } from "./DeleteVoteModal.vue?vue&type=template&id=4206ec9e&scoped=true"
import script from "./DeleteVoteModal.vue?vue&type=script&lang=js"
export * from "./DeleteVoteModal.vue?vue&type=script&lang=js"
import style0 from "./DeleteVoteModal.vue?vue&type=style&index=0&id=4206ec9e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4206ec9e",
  null
  
)

export default component.exports